import { atom } from "jotai";
import { SelectOption } from "@ir/ui";
import {
  deductionFilterAtom,
  DEFAULT_DEDUCTION_FILTER_PROPS,
  FilterInfo,
  QuickFIlterInfo,
} from "./deductionFilter.atoms";
import { FilterDateRange } from "@/presentation/deduction/components/DeductionFilter/interfaces";
import { mapMonthsToFilterDateRange } from "./utils";
import { ApprovalFilterInfo } from "@/store/approvals";
import { AnalyticsFilterInfo } from "@/store/analytics";
// Action atoms

export const setFilterAtom = atom(null, (get, set, filter: FilterInfo) => {
  set(deductionFilterAtom, {
    ...get(deductionFilterAtom),
    filterInfo: filter,
  });
});

export const clearFilterAtom = atom(null, (get, set, defaultFilter?: FilterInfo) => {
  set(deductionFilterAtom, {
    ...get(deductionFilterAtom),
    isFilterApplied: false,
    filterInfo: defaultFilter ?? {
      invoiceFromDate: null,
      invoiceToDate: null,
      checkFromDate: null,
      checkToDate: null,
      checkDateRange: FilterDateRange.LAST_3_MONTHS,
      invoiceDateRange: null,
      purchaser: [],
      dc: [],
      priority: [],
      validity: [],
      adjustmentTypes: [],
      adjustmentCategories: [],
      deductionTypeCategories: [],
      poNumberSearch: null,
      retailer: [],
      analyst: [],
      approver: [],
      progress: [],
    },
  });
});

export const setIsFilterAppliedAtom = atom(null, (get, set, isFilterApplied: boolean) => {
  set(deductionFilterAtom, {
    ...get(deductionFilterAtom),
    isFilterApplied: isFilterApplied,
  });
});

export const isDefaultFilter = (filterInfo: FilterInfo | ApprovalFilterInfo | AnalyticsFilterInfo, defaultCheckDateRangeInMonths = 3) => {
  return Object.entries(filterInfo).every(([key, value]) => {
    if (
      DEFAULT_DEDUCTION_FILTER_PROPS.includes(key as keyof FilterInfo) &&
      isDefaultDateRange(filterInfo, defaultCheckDateRangeInMonths)
    ) {
      return true;
    }
    if (Array.isArray(value)) {
      return value.length === 0;
    }
    return value === null || value === "";
  });
};

export const isDefaultDateRange = (filterInfo: FilterInfo | ApprovalFilterInfo | AnalyticsFilterInfo, defaultCheckDateRangeInMonths = 3) => {
  const defaultPreset = mapMonthsToFilterDateRange(defaultCheckDateRangeInMonths);

  if (defaultPreset) {
    return filterInfo.checkDateRange === defaultPreset && filterInfo.invoiceDateRange === null;
  }

  return (
    filterInfo.invoiceDateRange === null &&
    filterInfo.checkDateRange === null &&
    filterInfo.checkFromDate === null &&
    filterInfo.checkToDate === null
  );
};

export const setQuickFilterAtom = atom(null, (get, set, quickFilterInfo: QuickFIlterInfo) => {
  set(deductionFilterAtom, {
    ...get(deductionFilterAtom),
    quickFilterInfo: quickFilterInfo,
  });
});

export const setAnalystFilterFieldAtom = atom(null, (get, set, analyst: SelectOption[]) => {
  const current = get(deductionFilterAtom);
  set(deductionFilterAtom, {
    ...current,
    filterInfo: { ...current.filterInfo, analyst },
  });
});

